import React, { useEffect, useState } from 'react';
import { DeliveryMethod, TicketType } from '@arema/components/Classes';
import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { addCommas } from '@arema/components/Util';
import { Icon } from 'react-frontier2';
import API from '../API';

var SearchDeliveryModal = (props: SearchCoreProps<DeliveryMethod>)=>{
	return <SearchCoreModal 
		{...props}
		title='Formas de entrega'
		searchPlaceholder='Buscar formas de entrega'
		searchData={(query, page, size)=>{
			return API.getDeliveryMethods(query, (page*size), size);
		}}
		onShowLoad={(query, page, size)=>{
			return API.getPopularDeliveryMethods(page*size, size);
		}}
		table={[
			{ name: 'ID', key: 'delivery_id', collapsing: true },
			{ name: 'Entrega', key: 'method_name' },
			{ name: 'Tipo', collapsing: true, render: (v, delivery: DeliveryMethod)=>{
				return <>
					<Icon name={delivery.ticket_type===TicketType.DIGITAL ? 'qrcode' : 'print'} />
					{delivery.ticket_type===TicketType.DIGITAL ? 'Digital' : 'Impreso'}
				</>
			}},
			{ name: 'Costo', key: 'delivery_cost', collapsing: true, render: addCommas },
		]}
	/>
}

export default SearchDeliveryModal;